var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 153,
    viewBox: "0 0 177 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 152H78V44.4241C78 19.8893 97.6995 0 122 0V152Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133 0C157.301 0 177 19.9061 177 44.4615V153C152.699 153 133 133.094 133 108.538V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 82.8203H33.3462C52.7257 82.8203 68.4359 98.5305 68.4359 117.91C68.4359 137.29 52.7257 153 33.3462 153H0V82.8203Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000159341 0.000198364H21.8463C41.2258 0.000198364 56.9361 15.7104 56.9361 35.0899C56.9361 54.4695 41.2258 70.1797 21.8463 70.1797H0.000159341V0.000198364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.8a24d1fdd24dde9fd71755197e452328.svg";
export { ForwardRef as ReactComponent };